import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class QualityCheckHistoryService {
  O3CoreApiUrl: any = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getCheckListHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/GetAllQulaityCheckExecutions', data);
  }

  // getCheckListHistoryById(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'qualityexecution', data);
  // }

  getCheckListHistoryById(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/GetAllQulaityCheckExecutionById', data);
  }
  // getCheckListHistoryById(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'qualityexecution', data);
  // }
  verifyqualitychecklist(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/VerifyChecklist', data);
  }

  completequalitychecklist(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/ConfirmChecklist', data);
  }
  rejectqualitychecklist(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityChecklist/RejectChecklist', data);
  }

  plantUnit(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Machine/PlantUnit', data);
  }

  rejectquality(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/RejectChecklist', data);
  }

  GetChangeOverCheckListExecProdDetail(id:any): Observable<any[]>
  {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityCheckExecution/GetChangeOverCheckListExecProdDetail', id);
  }

  UpdateChangeOverChecklistExecution(data:any):Observable<any[]>
  {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityCheckExecution/UpdateChangeOverCheckListExecution' , data);
  }

  getChangeOverCheckListPartialSave(data:any):Observable<any[]>
  {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityCheckExecution/GetChangeOverCheckListPartialSave' , data);
  }
}
